import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  data: any;
  statusCode: number;
  message: string;
  s3Location?: string;
};

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postAddProperty: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.property,
        method: "POST",
        body,
      }),
      invalidatesTags: ["GETPROPERTY"]
    }),
    getPendingProperty: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        limit: number;
        propertyType?: string;
        category?: string;
        price?: string;
        agentId?: string;
        propertyName?: number;
        isDraftSaved?: boolean;
        companyId?: string;
        minPrice?: number | string;
        maxPrice?: number | string;
        startDate?: string;
        endDate?: string;
        listingType?: number | string;
        offerStatus?: number;
        lat?: number;
        long?: number;
        isExport?: boolean;
        isOffPlanProjects?: boolean;
        agencyType?: any;
        categoryParentId?: string;
        isRent?: boolean;
        isBuy?: boolean;
        furnished?: number;
        boostPlanType?: number;
      }
    >({
      query: ({
        page,
        search,
        limit,
        propertyType,
        category,
        price,
        agentId,
        propertyName,
        isDraftSaved,
        companyId,
        minPrice,
        maxPrice,
        startDate,
        endDate,
        listingType,
        offerStatus,
        lat,
        long,
        isExport,
        isOffPlanProjects,
        agencyType,
        categoryParentId,
        isRent,
        isBuy,
        furnished,
        boostPlanType
      }) => {
        let url = `${END_POINTS.property}?page=${page}&search=${search}&limit=${limit}&propertyTypeId=${propertyType}&companyId=${companyId}&categoryId=${category}&price=${price}&agentId=${agentId}&minPrice=${minPrice}&maxPrice=${maxPrice}&startDate=${startDate}&endDate=${endDate}&listingType=${listingType}${!isDraftSaved ? `&offerStatus=${offerStatus}` : ""}&lat=${lat}&long=${long}&propertyName=${propertyName}${agencyType ? `&agencyType=${agencyType}` : ""}${isBuy ? `&isBuy=${isBuy}` : ""}${isRent ? `&isRent=${isRent}` : ""}${categoryParentId ? `&categoryParentId=${categoryParentId}` : ""}${isExport ? '&isExport=true' : ''}${isOffPlanProjects ? '&isOffPlanProjects=true' : ''}${isDraftSaved ? `&isDraftSaved=true` : ""}${furnished ? `&furnished=${furnished}` : ""}${boostPlanType ? `&boostPlanType=${boostPlanType}`:"" }`;

        return {
          url: url,
          method: "GET",
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["GETPROPERTY"]
    }),


    getSpecificPropertyById: builder.query<
      CommonResponseType & { data: any },
      { userId: any; isDraft?: boolean, }
    >({
      query: ({ userId, isDraft }) => ({
        url: `${END_POINTS.property}/${userId}${isDraft ? `?isDraftSaved=true` : ""}`,
        method: "GET",
      }),
    }),
    popertyChatById: builder.query<
      CommonResponseType & { data: any },
      { userId: any }
    >({
      query: ({ userId }) => ({
        url: `${END_POINTS.chats}?propertyId=${userId}`,
        method: "GET",
      }),
    }),

    EditProperty: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.property}/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["GETPROPERTY"]
    }),

    deleteByIdProperty: builder.mutation<
      CommonResponseType & { data: any },
      { userId: any }
    >({
      query: ({ userId }) => ({
        url: `${END_POINTS.property}/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["GETPROPERTY"]
    }),

    deleteDraftByIdProperty: builder.mutation<
      CommonResponseType & { data: any },
      { userId: any }
    >({
      query: ({ userId }) => ({
        url: `${END_POINTS.property}/drafts/delete/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["GETPROPERTY"]
    }),


    getAmenitiesListing: builder.query<CommonResponseType, {}>({
      query: ({ }) => {
        let url = END_POINTS.amenitiesListing;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getpropertYTypeListing: builder.query<CommonResponseType, {}>({
      query: ({ }) => {
        let url = END_POINTS.propertyTypeListing;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getpropertyTypeOffplanListing: builder.query<CommonResponseType, { isOffPlanProjects?: boolean, agencyType?: any }>({
      query: ({ isOffPlanProjects, agencyType }) => {
        let url = `${END_POINTS.propertyTypeListing}/listing${isOffPlanProjects ? "?isOffPlanProjects=true" : ""}${agencyType ? `?agencyType=${agencyType}` : ""}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getPropertyRequestForUnderOffer: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        limit: number;
        startDate?: string;
        endDate?: string;
        underOfferStatus?: number;
      }
    >({
      query: ({
        page,
        search,
        limit,
        startDate,
        endDate,
        underOfferStatus,

      }) => {
        let url = `${END_POINTS.property}?page=${page}&search=${search}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&underOfferStatus=${underOfferStatus}&offerStatus=3`;
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getPropertyRequestForClaimedProperty: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        limit: number;
        startDate?: string;
        endDate?: string;
        isClaimDocStatus?: number;
        isPublish?: boolean;
      }
    >({
      query: ({
        page,
        search,
        limit,
        startDate,
        endDate,
        isClaimDocStatus,
        isPublish
      }) => {
        let url = `${END_POINTS.property}?page=${page}&search=${search}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&isClaimDocStatus=${isClaimDocStatus}&offerStatus=2&isPublish=${isPublish}`;
        return {
          url: url,
          method: "GET",
        };
      },
    }),


    getPropertyForCategoryDetails: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        limit: number;
        category?: string;
      }
    >({
      query: ({
        page,
        limit,
        category,
      }) => {
        let url = `${END_POINTS.property}?page=${page}&limit=${limit}&categoryId=${category}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getPropertiesForCompany: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        limit: number;
        userId: any;
        offerStatus: any;
        isClaimDocStatus?: any;
        isPublish?: any;
        search?: any;
        propertyTypeId?: string;
        categoryId?: string;
        listingType?: number | string;
        agencyType?: number | string;
        categoryParentId?: string;
        companyId?: string;
        isRent?: boolean;
        isBuy?: boolean;

      }
    >({
      query: ({
        page,
        limit,
        userId,
        offerStatus,
        isClaimDocStatus,
        isPublish,
        search,
        propertyTypeId,
        categoryId,
        listingType,
        agencyType,
        categoryParentId,
        companyId,
        isBuy,
        isRent,

      }) => {
        let url = `${END_POINTS.property}?page=${page}&limit=${limit}${companyId ? `&companyId=${companyId}` : ""}${userId ? `&userId=${userId}` : ""}&search=${search}&offerStatus=${offerStatus}${isClaimDocStatus ? `&isClaimDocStatus=${isClaimDocStatus}` : ""}${isPublish ? `&isPublish=false` : ""}${categoryParentId ? `&categoryParentId=${categoryParentId}` : ""}${propertyTypeId ? `&propertyTypeId=${propertyTypeId}` : ""}${categoryId ? `&categoryId=${categoryId}` : ""}${listingType ? `&listingType=${listingType}` : ""}${agencyType ? `&agencyType=${agencyType}` : ""}${isBuy ? `&isBuy=true` : ""}${isRent ? `&isRent=true` : ""}`;
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getXmlProperties: builder.query<
      CommonResponseType & { data: any },
      {
        propertyType: number; companyId?: string, page: number, limit: number, search: string, startDate?: string;
        endDate?: string;
      }
    >({
      query: ({ propertyType, companyId, page, limit, search, startDate, endDate }) => ({
        url: `${END_POINTS.xmlProperties}?propertyType=${propertyType}&page=${page}&limit=${limit}&search=${search}${companyId ? `&companyId=${companyId}` : ""}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
      }),
    }),

    getXmlRecords: builder.query<
      CommonResponseType & { data: any },
      {
        companyId?: string, page: number, limit: number, search: string, startDate?: string;
        endDate?: string; autoXmlType?: string;
      }
    >({
      query: ({ companyId, page, limit, search, startDate, endDate }) => ({
        url: `${END_POINTS.autoXmlHistory}?companyId=${companyId}&page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
      }),
    }),

    getXmlRecordsDetails: builder.query<
      CommonResponseType & { data: any },
      {
        id?: string, page: number, limit: number, search: string, startDate?: string;
        endDate?: string; autoXmlType?: number;
      }
    >({
      query: ({ id, page, limit, search, startDate, endDate, autoXmlType }) => ({
        url: `${END_POINTS.autoXmlHistory}/${id}?page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}${autoXmlType ? `&autoXmlType=${autoXmlType}` : ""}`,
        method: "GET",
      }),
    }),


    refreshProperties: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => {
        let url = `${END_POINTS.refreshProperties}/${id}`;

        return {
          url: url,
          method: "PUT",
        };
      },
    }),


  }),
});

export const {
  usePostAddPropertyMutation,
  useGetPendingPropertyQuery,
  useLazyGetPendingPropertyQuery,
  useLazyGetSpecificPropertyByIdQuery,
  useEditPropertyMutation,
  useDeleteByIdPropertyMutation,
  useDeleteDraftByIdPropertyMutation,
  useLazyGetAmenitiesListingQuery,
  useLazyGetpropertYTypeListingQuery,
  useLazyGetpropertyTypeOffplanListingQuery,
  useLazyPopertyChatByIdQuery,
  useLazyGetPropertyRequestForUnderOfferQuery,
  useLazyGetPropertyRequestForClaimedPropertyQuery,
  useLazyGetPropertyForCategoryDetailsQuery,
  useLazyGetPropertiesForCompanyQuery,
  useLazyGetXmlPropertiesQuery,
  useLazyGetXmlRecordsQuery,
  useLazyGetXmlRecordsDetailsQuery,
  useRefreshPropertiesMutation
} = authApi;
